module.exports = "p {\n  color: white;\n  width: 50vw;\n  font-size: 45px;\n  margin-top: 33vh;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.css
// module id = ./src/app/about/about.component.css
// module chunks = main